<template>
  <div
    :class="[
      $style.helperText,
      {
        [$style.alert]: intent === 'alert',
        [$style.success]: intent === 'success',
        [$style.warning]: intent === 'warning',
      },
    ]"
  >
    <SCASvgIcon
      v-if="(intent || hasNoneIntentIcon) && showIcon"
      :class="[
        $style.svg,
        {
          [$style.alert]: intent === 'alert',
          [$style.success]: intent === 'success',
          [$style.warning]: intent === 'warning',
        },
      ]"
      :icon="icon"
      size="12px"
    />
    <span v-if="$slots['default']"><slot /></span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import SCASvgIcon from "./SCASvgIcon.vue";

const props = withDefaults(
  defineProps<{
    intent?: "alert" | "success" | "warning";
    hasNoneIntentIcon?: boolean;
    showIcon?: boolean;
  }>(),
  {
    intent: undefined,
    hasNoneIntentIcon: false,
    showIcon: true,
  },
);
const icon = computed(() => {
  switch (props.intent) {
    case "alert":
      return "phosphor/info";
    case "success":
      return "phosphor/check";
    case "warning":
      return "phosphor/warning-fill";
    default:
      return "phosphor/info-fill";
  }
});
</script>

<style lang="scss" module>
@use "../styles/generated/figma_typo_mixins.scss" as FigmaTypoMixins;
@use "../styles/icon.scss" as IconMixins;

.helperText {
  @include FigmaTypoMixins.typo-body-xsmall;
  display: flex;
  align-items: start;
  gap: var(--space-component-gap-xSmall);
  color: var(--sca-helper-text-color, var(--color-content-secondary));

  svg {
    flex-shrink: 0;
    @include IconMixins.icon-color(var(--color-content-secondary));
    &.alert {
      @include IconMixins.icon-color(var(--color-content-negative-secondary));
    }
    &.success {
      @include IconMixins.icon-color(var(--color-content-positive-secondary));
    }
    &.warning {
      @include IconMixins.icon-color(var(--color-content-warning-secondary));
    }
  }

  &.alert {
    color: var(--color-content-negative-secondary);
  }
  &.success {
    color: var(--color-content-positive-secondary);
  }
  &.warning {
    color: var(--color-content-warning-secondary);
  }
}
</style>
